import { post } from '@namespace/helpers';
import apiRoutes from './apiRoutes';

export const getFreshChatUser = () => post(apiRoutes.getFreshChatUserData, {}); // out to chats
